module.exports = __webpack_public_path__ + "static/img/PC-7.eae528b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcga/PC-7.png
// module id = a7Ps
// module chunks = 0